import { render, staticRenderFns } from "./PopupContentIntroImgOutro.vue?vue&type=template&id=2e6c59a8"
import script from "./PopupContentIntroImgOutro.vue?vue&type=script&lang=js"
export * from "./PopupContentIntroImgOutro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports